import { createAction } from 'redux-actions'

export const GET_SERIE = createAction('GET_SERIE')
export const GET_SERIE_START = createAction('GET_SERIE_START')
export const GET_SERIE_SUCCESS = createAction('GET_SERIE_SUCCESS')
export const GET_SERIE_ERROR = createAction('GET_SERIE_ERROR')
export const GET_SERIE_FINALLY = createAction('GET_SERIE_FINALLY')
export const GET_SERIES = createAction('GET_SERIES')
export const GET_SERIES_START = createAction('GET_SERIES_START')
export const GET_SERIES_SUCCESS = createAction('GET_SERIES_SUCCESS')
export const GET_SERIES_ERROR = createAction('GET_SERIES_ERROR')
export const GET_SERIES_FINALLY = createAction('GET_SERIES_FINALLY')